module.exports = __webpack_public_path__ + "static/Branches-f6fb3117779c79d2a0f1bcd604e3a25c.png";